import { createStore, Store, useStore as useVuexStore } from 'vuex'
import { IRootState, IStoreState } from '@/store/types'
import login from '@/store/login/login'
import system from '@/store/main/system/system'

const store = createStore<IRootState>({
  state: () => {
    return {
      name: 'jstd'
    }
  },
  modules: {
    login,
    system
  }
})

export function setupStore() {
  store.dispatch('login/loadLocalAction')
}

export function useStore(): Store<IStoreState> {
  return useVuexStore()
}

export default store
